import React, { ReactNode } from 'react';

interface DropdownProps
	{
	title?: string;
	className?: string;
	children: ReactNode;
	}

export const Dropdown = ({ title, className = '', children }: DropdownProps) =>
	{
	return (
		<div className={`booking-bar__dropdown ${className}`}>
			{title && <p className="booking-bar__dropdown-title">{title}</p>}
			{children}
		</div>
	);
	};
